import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { CHAT_MOBILE_COLORS } from '@/constants/residents/mobile/chatColors';
import { SVG_COMPONENTS } from '@/assets/admin';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const ThumbUpIcon = SVG_COMPONENTS.THUMB_UP;
const StartConvoIcon = RESIDENTS_SVG_COMPONENTS.START_CONVO;

export type ChatEmptyStateType = 'noMessages' | 'startConversation';

interface ChatEmptyStateProps {
  type: ChatEmptyStateType;
}

const EMPTY_STATE_CONFIG = {
  noMessages: {
    title: 'No messages',
    subtitle: 'You have no messages at the moment',
    Icon: ThumbUpIcon,
    iconSize: { width: 68, height: 68 },
  },
  startConversation: {
    title: 'Start conversation',
    subtitle: 'Enter subject, then type your message.',
    Icon: StartConvoIcon,
    iconSize: { width: 77, height: 68 },
  },
};

/**
 * Empty state component for chat screens
 * Displays appropriate icon and message based on context
 */
export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({ type }) => {
  const config = EMPTY_STATE_CONFIG[type];
  const { Icon, iconSize, title, subtitle } = config;

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Icon 
          width={iconSize.width} 
          height={iconSize.height} 
          color={CHAT_MOBILE_COLORS.textMuted} 
        />
      </View>
      <View style={styles.textContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: 68,
    paddingHorizontal: 24,
  },
  iconContainer: {
    marginBottom: 18,
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: CHAT_MOBILE_COLORS.textPrimary,
    lineHeight: 24,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    fontWeight: '400',
    color: CHAT_MOBILE_COLORS.textMuted,
    lineHeight: 21,
    textAlign: 'center',
  },
});

export default ChatEmptyState;
